import { dramas } from '@/mocks/dramas';
import { getHotNews } from '@/lib/data';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntry from './components/CategoryEntry';
import LatestSection from './components/LatestSection';
import NewsSidebar from './components/NewsSidebar';
import IntroSection from './components/IntroSection';

const featuredIds = ['seoul-nocturne', 'silent-testimony', 'memory-maze', 'shadow-throne'];

export default function Home() {
  const featured = featuredIds
    .map((id) => dramas.find((d) => d.id === id))
    .filter((d): d is (typeof dramas)[number] => Boolean(d));
  const hotNews = getHotNews(5);

  return (
    <>
      <h1 className="sr-only">韩剧 - 最新韩剧在线观看与剧情资讯平台</h1>
      <HeroCarousel items={featured} />
      <CategoryEntry />

      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 items-start">
          <div className="flex-1 min-w-0 w-full">
            <LatestSection />
          </div>
          <NewsSidebar items={hotNews} />
        </div>
      </div>

      <IntroSection />
    </>
  );
}